// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"layout_mainContainer__22NM_"};